module.exports = __webpack_public_path__ + "77020468a3033f138b192121f258731f.pdf";